(function () {
    angular.module('agweb').controller('UniqueApproachController', [
        function UniqueApproachController() {
            var ctrl = this;

            ctrl.ux = {};

            ctrl.setSlideIndex = 0;
            ctrl.largeSlideIndex = 0;

            //-
            ctrl.slideNavigate = function ($event) {
                // Set the slide index when large image is navigated,
                // so the small gallery can sync with it.
                ctrl.largeSlideIndex = $event.index;
            };

            // Make the large slide set to the index of the image clicked in the gallery
            ctrl.showImage = function ($event) {
                if ($event.item) {
                    ctrl.setSlideIndex = $event.index;
                }
            };
            
            ctrl.init = function () {
                ctrl.Images = [
                    { "Full": "images/OUAImages/Poolhead 0001.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0001.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0002.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0002.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0003.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0003.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0004.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0004.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0005.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0005.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0006.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0006.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0007.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0007.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0008.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0008.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0009.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0009.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0010.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0010.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0011.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0011.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0012.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0012.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0013.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0013.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0014.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0014.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0015.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0015.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0016.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0016.jpg" },
                    { "Full": "images/OUAImages/Poolhead 0017.jpg", "Thumb": "images/OUAImages/thumbs/Poolhead 0017.jpg" }
                ];
            };

            //-i

            ctrl.init();
        }
    ]);
})();